<div class="customer-information-container">
  <div class="title-container">
    <h2 class="title">{{ titleHeading }}</h2>
    <p
      *ngIf="hasExistingVehicles && vehicleCount < 5"
      class="add-vehicle-link"
      (click)="onAddNewVehicle()"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 3.33333V12.6667M3.33333 8H12.6667"
          stroke="#326FD1"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      Add new vehicle
    </p>
  </div>
  <!-- Show add new vehicle form when adding new vehicle -->
  <div class="card-view" *ngIf="isAddingNewVehicle">
    <app-vehicle-list
      *ngIf="isAddingNewVehicle"
      #addVehicleComponent
      [customerId]="customerId"
      [showSaveCancelButtons]="false"
      (formValidityChange)="onFormValidityChange($event)"
      (formDataChange)="onVehicleFormDataChange($event)"
      (vehicleCreatedManually)="onVehicleCreatedManually($event)"
      (manualFieldsVisibilityChange)="onManualFieldsVisibilityChange($event)"
    >
    </app-vehicle-list>

    <!-- Add vehicle action buttons when adding new vehicle - Hide when manual fields are showing -->
    <div *ngIf="isAddingNewVehicle && !showManualVehicleFields" class="add-vehicle-actions">
      <button type="button" class="btn btn-tertiary btn-small" (click)="onCancelAddVehicle()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-secondary btn-small"
        [ngClass]="{ disabled: !step4FormValid }"
        [disabled]="!step4FormValid"
        (click)="onSaveNewVehicle()"
      >
        Save
      </button>
    </div>
  </div>
  <div class="form-container">
    <div class="form-content">
      <ng-content></ng-content>
    </div>
    <app-modal-footer-actions
      footerClass="modal-footer"
      secondaryText="Cancel"
      cancelText="Back"
      [primaryText]="currentStep === 4 ? 'Confirm' : 'Continue'"
      primaryLoadingText="Processing..."
      [showCancel]="currentStep !== 1"
      [secondaryDesktopOnly]="true"
      [primaryDisabled]="
        (requiresValidation && !isFormValid) ||
        isProcessing ||
        isDisabled ||
        (requiresActivePackage && (hasPackages$ | async) !== true)
      "
      [primaryLoading]="isProcessing"
      [primaryExtraClass]="{
        disabled:
          (requiresValidation && !isFormValid) ||
          isProcessing ||
          isDisabled ||
          (requiresActivePackage && (hasPackages$ | async) !== true),
      }"
      (secondaryClick)="onCancelClick()"
      (cancelClick)="onBackClick()"
      (primaryClick)="Continue()"
    />
  </div>
</div>
